import React from 'react';

import cs from 'classnames';
import {colors} from 'js-libs/sweetcommons/styles';
import moment from 'moment-tz';
import styled from 'styled-components';

import {useCurrentUserState} from 'app/current-user/api';
import {
  getTimezonedDayEnd,
  GuestAccessUntilField,
} from 'app/user/components/GuestAccessUntilField';
import {gt} from 'app/utils/i18n';

interface Props {
  is_guest_until: string | undefined;
  onChange: (is_guest_until: string | undefined) => unknown;
  small?: boolean;
}

export function GuestUserToggleField({
  is_guest_until,
  onChange,
  small = false,
}: Props): JSX.Element {
  const {timezone} = useCurrentUserState().data!;
  const [showingGuestHelp, setShowGuestHelp] = React.useState(false);

  return (
    <>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          onChange={() => {
            setShowGuestHelp(false);
            onChange(
              is_guest_until == null
                ? getTimezonedDayEnd(moment().add(14, 'days'), timezone)
                : undefined
            );
          }}
          checked={is_guest_until != null}
          id="isGuestId"
        />
        <label
          className="form-check-label"
          htmlFor="isGuestId"
          style={{fontSize: small ? '.875rem' : undefined}}
          title={gt('This member will only have guest access.')}
        >
          {gt('Guest Access Only')}{' '}
          <button
            className="btn btn-link p-0"
            onClick={() => setShowGuestHelp(!showingGuestHelp)}
            type="button"
          >
            <i className="fa fa-fw fa-info-circle" />
          </button>
        </label>
      </div>
      {is_guest_until != null || showingGuestHelp ? (
        <BorderContainerDiv small={small} active={true} className="mt-2">
          {is_guest_until != null ? (
            <>
              <GuestAccessUntilField
                is_guest_until={is_guest_until}
                onChange={onChange}
              />
              <hr />
            </>
          ) : null}
          <div className={cs({small})}>
            <p>
              {gt(
                "Guest members have limited access to SweetProcess documents. They can only be assigned a task. They don't have access to any procedures/policies/processes in your account and can't see teams or other members (except data related with a task they get access to)."
              )}
            </p>
            <p>
              {gt(
                "A guest member's access is time-based (guest member cannot access any assigned tasks when it's account expires)"
              )}
            </p>
          </div>
        </BorderContainerDiv>
      ) : null}
    </>
  );
}

const BorderContainerDiv = styled.div<{small?: boolean; active?: boolean}>`
  margin-left: 0.3rem;
  padding-left: 0.75rem;
  border-left: ${({small}) => (small ? '2' : '3')}px solid
    ${({active}) => (active ? colors.linkBlue : colors.lightGray)};
`;
